
module.exports = require('./js/definition');
require('./js/i18n');
require('./js/defaults');
require('./js/plugins');
